const o = ":host{display:block;animation:sl-alert-in var(--sl-transition-normal) var(--sl-transition-timing-out)}:host(.sl-alert--removing){animation:sl-alert-out var(--sl-transition-normal) var(--sl-transition-timing-in)}.sl-alert{display:flex;align-items:flex-start;gap:var(--sl-spacing-3);padding:var(--sl-spacing-3) var(--sl-spacing-4);border-radius:var(--sl-radius-lg);border:var(--sl-border-1) solid transparent;font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);line-height:var(--sl-line-height-relaxed);color:var(--sl-foreground);background-color:var(--sl-alert-bg);border-color:var(--sl-alert-border-color)}.sl-alert__icon{flex-shrink:0;width:1.25rem;height:1.25rem;margin-top:0.125rem}.sl-alert__icon--success{color:hsl(var(--sl-hsl-success))}.sl-alert__icon--error{color:hsl(var(--sl-hsl-destructive))}.sl-alert__icon--warning{color:hsl(var(--sl-hsl-warning))}.sl-alert__icon--info{color:hsl(var(--sl-hsl-info))}.sl-alert__content{flex:1;min-width:0}.sl-alert__title{display:block;font-weight:var(--sl-font-weight-semibold);margin-bottom:var(--sl-spacing-1)}.sl-alert__message{color:inherit}.sl-alert__close{flex-shrink:0;width:1.5rem;height:1.5rem;display:inline-flex;align-items:center;justify-content:center;border:none;background:transparent;color:inherit;opacity:0.6;cursor:pointer;border-radius:var(--sl-radius-sm);font-size:1.125rem;line-height:1;transition:opacity var(--sl-transition-fast) var(--sl-transition-timing-out),background-color var(--sl-transition-fast) var(--sl-transition-timing-out)}.sl-alert__close:hover{opacity:1;background-color:var(--sl-alert-close-bg-hover,rgba(0,0,0,0.05))}.sl-alert--info{--sl-alert-bg:var(--sl-info-bg);--sl-alert-color:var(--sl-info);--sl-alert-border-color:var(--sl-info-border)}.sl-alert--success{--sl-alert-bg:var(--sl-success-bg);--sl-alert-color:var(--sl-success);--sl-alert-border-color:var(--sl-success-border)}.sl-alert--warning{--sl-alert-bg:var(--sl-warning-bg);--sl-alert-color:var(--sl-warning);--sl-alert-border-color:var(--sl-warning-border)}.sl-alert--error{--sl-alert-bg:var(--sl-destructive-bg);--sl-alert-color:var(--sl-destructive);--sl-alert-border-color:var(--sl-destructive-border)}.sl-alert--default{--sl-alert-bg:var(--sl-card-bg);--sl-alert-color:var(--sl-foreground);--sl-alert-border-color:var(--sl-border-color)}@keyframes sl-alert-in{from{opacity:0;transform:translateY(-0.5rem)}to{opacity:1;transform:translateY(0)}}@keyframes sl-alert-out{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(-0.5rem)}}";
class n extends HTMLElement {
  constructor() {
    super(), this._closeBtnHandler = null, this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  static get observedAttributes() {
    return ["variant", "dismissible", "title"];
  }
  disconnectedCallback() {
    this._closeBtnHandler && (this._shadow.querySelector(".sl-alert__close")?.removeEventListener("click", this._closeBtnHandler), this._closeBtnHandler = null);
  }
  attributeChangedCallback(s, e, r) {
    e !== r && this._render();
  }
  get variant() {
    return this.getAttribute("variant") || "default";
  }
  set variant(s) {
    this.setAttribute("variant", s);
  }
  get dismissible() {
    return this.hasAttribute("dismissible");
  }
  set dismissible(s) {
    s ? this.setAttribute("dismissible", "") : this.removeAttribute("dismissible");
  }
  get title() {
    return this.getAttribute("title") || "";
  }
  set title(s) {
    this.setAttribute("title", s);
  }
  dismiss() {
    this.classList.add("sl-alert--removing");
    const s = parseInt(
      getComputedStyle(this).getPropertyValue("--sl-transition-normal") || "250",
      10
    ) || 250;
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("dismiss", { bubbles: !0, composed: !0 })), this.remove();
    }, s);
  }
  _getIcon(s) {
    switch (s) {
      case "success":
        return '<svg class="sl-alert__icon sl-alert__icon--success" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>';
      case "error":
        return '<svg class="sl-alert__icon sl-alert__icon--error" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.293 6.293a1 1 0 011.414 0L10 7.586l1.293-1.293a1 1 0 111.414 1.414L11.414 9l1.293 1.293a1 1 0 01-1.414 1.414L10 10.414l-1.293 1.293a1 1 0 01-1.414-1.414L8.586 9 7.293 7.707a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>';
      case "warning":
        return '<svg class="sl-alert__icon sl-alert__icon--warning" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>';
      case "info":
        return '<svg class="sl-alert__icon sl-alert__icon--info" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>';
      default:
        return "";
    }
  }
  _render() {
    const s = this.variant, e = ["sl-alert", `sl-alert--${s}`], r = this._getIcon(s), t = this.title, a = t ? `<strong class="sl-alert__title">${t}</strong>` : "", i = this.dismissible ? '<button class="sl-alert__close" aria-label="Dismiss">×</button>' : "";
    this._shadow.innerHTML = `
      <style>${o}</style>
      <div class="${e.join(" ")}" role="alert">
        ${r}
        <div class="sl-alert__content">
          ${a}
          <div class="sl-alert__message"><slot></slot></div>
        </div>
        ${i}
      </div>
    `;
    const l = this._shadow.querySelector(".sl-alert__close");
    l && (this._closeBtnHandler = () => this.dismiss(), l.addEventListener("click", this._closeBtnHandler));
  }
}
typeof customElements < "u" && !customElements.get("sl-alert") && customElements.define("sl-alert", n);
export {
  n as SlAlertElement
};
//# sourceMappingURL=sl-alert.js.map
